import httpClient from "@plugins/http";
import { ApiResponse } from "@apis/api.ts";
import {
  WebsiteResourceDataTableInput,
  WebsiteResourceDataTableOutput,
  WhitelistDomainMetadataModel,
  WhitelistWebsiteDetailModel,
  WhitelistWebsiteFormData,
  WhitelistWebsiteModel,
} from "@modules/whitelist-website/types.ts";
import { notNull } from "@utils/var.check.ts";

const fetchWhitelistWebsiteDetails = (
  websiteUuid: string,
): Promise<ApiResponse<WhitelistWebsiteDetailModel>> => {
  return httpClient.get(`/apis/whitelist-website/details/${websiteUuid}`);
};

const fetchWhitelistWebsite = (
  websiteUuid: string,
): Promise<ApiResponse<WhitelistWebsiteModel>> => {
  return httpClient.get(`/apis/whitelist-website/get/${websiteUuid}`);
};

const fetchWhitelistWebsites = (
  requestData: WebsiteResourceDataTableInput,
): Promise<ApiResponse<WebsiteResourceDataTableOutput>> => {
  const data = new URLSearchParams();
  Object.keys(requestData).forEach((key) => {
    if (notNull(requestData[key])) {
      data.append(key, requestData[key]);
    }
  });
  return httpClient.get(`/apis/whitelist-website/manage-resource/list`, {
    params: data,
  });
};

const toggleEnableWebsite = (websiteUuid: string): Promise<ApiResponse<WhitelistWebsiteModel>> => {
  return httpClient.post(`/apis/whitelist-website/toggle-enable/${websiteUuid}`);
};

const deleteWebsite = (websiteUuid: string): Promise<ApiResponse> => {
  return httpClient.post(`/apis/whitelist-website/delete/${websiteUuid}`);
};

const createWhitelistWebsite = (
  formData: WhitelistWebsiteFormData,
): Promise<ApiResponse<string>> => {
  return httpClient.post(`/apis/whitelist-website/create`, formData);
};

const updateWhitelistWebsite = (
  formData: WhitelistWebsiteFormData,
): Promise<ApiResponse<string>> => {
  return httpClient.post(`/apis/whitelist-website/update`, formData);
};

const fetchWhitelistDomainMaps = (): Promise<ApiResponse<Record<string, string>>> => {
  return httpClient.get(`/apis/whitelist-website/domain/list`);
};

const fetchWhitelistWebsiteInfo = (
  domainUuid: string,
): Promise<ApiResponse<WhitelistWebsiteDetailModel>> => {
  return httpClient.get(`/apis/whitelist-website/domain/get-website/${domainUuid}`);
};

const fetchWhitelistDomainMetadata = (
  domainUuid: string,
): Promise<ApiResponse<WhitelistDomainMetadataModel>> => {
  return httpClient.get(`/apis/whitelist-website/get-metadata/${domainUuid}`);
};

export default {
  fetchWhitelistWebsiteDetails,
  fetchWhitelistWebsite,
  fetchWhitelistWebsites,
  toggleEnableWebsite,
  deleteWebsite,
  createWhitelistWebsite,
  updateWhitelistWebsite,
  fetchWhitelistDomainMaps,
  fetchWhitelistWebsiteInfo,
  fetchWhitelistDomainMetadata,
};
